import React, { Component } from 'react'
import { Button, Drawer, Form, Select } from 'antd';
import Swal from "sweetalert2";
import { set_auth } from "../../reducers/Auth";
import { connect } from "react-redux";
import {withTourGuide} from "../guideComponent/withTourGuide";

class Add extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            divisi_name: '',
            divisi_sift: '',
            divisi_payroll_type: '',
            shift: []
        }
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    simpanDivisi = () => {
        this.setState({
            loading: true
        })
        let form = {
            name: this.state.divisi_name,
            divisi_sift: this.state.divisi_sift,
            payroll: this.state.divisi_payroll_type
        }

        this.props.request("divisi/add", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    const filter_data = JSON.parse(localStorage.getItem('Presensi-Company-Data'))
                    if (filter_data && filter_data._divisi) {
                        filter_data._divisi.push({
                            divisi_id           : response.data.divisi_id,
                            perusahaan_id       : response.data.perusahaan_id,
                            divisi_name         : response.data.divisi_name,
                            divisi_payroll_type : response.data.divisi_payroll_type,
                            divisi_create_date  : response.data.divisi_create_date,
                        });
                        localStorage.setItem('Presensi-Company-Data', JSON.stringify(filter_data));
                    }
                    this.setState({ divisi_name: '', divisi_sift: ''})
                    this.props.set_auth(this.props.api_token, response.perusahaan);
                    this.props.changeState({
                        divisi_name: '',
                        add_visible: false
                    }, () => this.props.loadData())
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                }
                if (response && response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
            });
    }

    loadShift() {
        let form = {}
        this.props.request("shift/list", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        shift: response.data.data
                    })
                }
            });
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    componentDidMount() {
        this.loadShift()
    }

    render() {
        const { Option } = Select;
        return (
            <Drawer
                title="Tambah Divisi"
                width={350}
                onClose={() => {
                    this.props.changeState({ add_visible: false, divisi_name: '' });
                }}
                visible={this.props.add_visible}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={() => {
                            this.props.changeState({ add_visible: false, divisi_name: '' });
                        }}
                            style={{ marginRight: 8 }}>
                            Batal
                        </Button>
                        <Button onClick={this.simpanDivisi} disabled={this.state.loading} type="primary">
                            Simpan
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical" hideRequiredMark>
                    <div className="form-group">
                        <label>Nama Divisi</label>
                        <input name="divisi_name" className="form-control col-xl-12 col-md-12" placeholder="Nama Divisi..."
                            type="text" required="" value={this.state.divisi_name}
                            onChange={(event) => {
                                const target = event.target;
                                const value = target.value;
                                const name = target.name;
                                this.setState({
                                    [name]: value
                                });
                            }}
                            onPointerEnter={(e) => {
                                this.triggerGuideOnce(e, {
                                    key: "namaDivisiAdd",
                                    title: "Nama Divisi",
                                    content: "Masukkan nama divisi yang akan dibuat. Contoh: Produksi, HRD, atau Marketing."
                                });
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <label>Shift Divisi</label>
                        <span onPointerEnter={(e) => {
                            this.triggerGuideOnce(e, {
                                key: "shiftDivisiAdd",
                                title: "Shift Divisi",
                                content: "Pilih shift kerja yang akan digunakan oleh divisi ini. Divisi dapat menggunakan satu atau beberapa shift yang tersedia."
                            });
                        }}>
                            <Select name="divisi_sift"
                                    style={{ width: '100%' }}
                                    mode={"multiple"}
                                    placeholder="Pilih Shift"
                                    data_karyawan
                                    onChange={(event) => {
                                        this.setState({
                                            divisi_sift: event
                                        })
                                    }}>
                                {this.state.shift.map((item, index) => {
                                    return (<Option key={item.sift_id}>{item.sift_name}</Option>)
                                })}
                            </Select>
                        </span>
                    </div>
                    <div className="form-group">
                        <label>Perhitungan Gaji</label>
                        <span
                            onPointerEnter={(e) => {
                                this.triggerGuideOnce(e, {
                                    key: "perhitunganGajiAdd",
                                    title: "Perhitungan Gaji",
                                    content: "Pilih metode perhitungan gaji untuk divisi ini. Contohnya berdasarkan hari kerja atau metode lain yang tersedia."
                                });
                            }}
                        >
                            <select
                                name="divisi_payroll_type"
                                className="form-control col-xl-12 col-md-12"
                                value={this.state.divisi_payroll_type}
                                onChange={(event) => this.handleChange(event)}>
                                <option value="">Pilih Perhitungan Gaji</option>
                                <option value="jam">Jam</option>
                                <option value="hari">Hari</option>
                                <option value="bulan">Bulan</option>
                            </select>
                        </span>
                    </div>
                </Form>
            </Drawer>

        )
    }
}

const mapStateToProps = state => ({
    auth: state.Auth.auth,
    api_token: state.Auth.api_token
})

const mapDispatchToProps = dispatch => ({
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withTourGuide(Add))
